import { render } from "./WindLoadStaticLow.vue?vue&type=template&id=0f3c88d4&scoped=true"
import script from "./WindLoadStaticLow.vue?vue&type=script&lang=js"
export * from "./WindLoadStaticLow.vue?vue&type=script&lang=js"

import "./WindLoadStaticLow.vue?vue&type=style&index=0&id=0f3c88d4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f3c88d4"]])

export default __exports__